import { Markup } from '@/components/Markup';
import { LabradorComponent } from '@/types/component';
import { widthToClass } from '@/utils/widthToClass';

export const LabradorMarkup: LabradorComponent = ({ type, meta, data }) => {
  const widthClass = widthToClass(meta.width);

  return <Markup markup={data.markup} options={{ className: widthClass }} data-content-index={meta.contentIndex} />;
};
